import React, { useEffect, useState } from "react";
import { Grid, Box, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { getTrip } from "redux/actions/UserTrip";
import Loader from "components/loader/Loader";
import LocationDropdown from 'components/LocationDropdown/LocationDropdown';
import CommonTable from "components/commonTable/CommonTable";
import { debounce } from "lodash";
import CommonSDF from "components/commonSDF/CommonSdf";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import { setCurrentTab } from 'redux/actions/TabActions';

function Invoice() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { tabs } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState("");
  const currentTab = useSelector(state => state?.rideTrack?.currentTab) || tabs;

  // Get query parameters
  const pageQuery = searchParams.get('page');
  const pageSizeQuery = searchParams.get('pageSize');

  // State from Redux
  const tableData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const loading = useSelector((state) => state?.userTrip?.loading);
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);

  // Constants
  const STATUS_FILTERS = ["completed"];
  const DEFAULT_PAGE = 0;
  const DEFAULT_PAGE_SIZE = 10;

  const tripNameMap = {
    "": "",
    "1": "Ride",
    "5": "Rental",
    "4": "Airport",
    "7": "outStation"
  }

  // Local state derived from URL params
  const page = pageQuery ? parseInt(pageQuery) : DEFAULT_PAGE;
  const pageSize = pageSizeQuery ? parseInt(pageSizeQuery) : DEFAULT_PAGE_SIZE;

  // Filter data object
  const getFilterData = (currentPage, currentPageSize) => {
    // Ensure we have a valid location ID
    // if (!selectedLocation?.id) {
    //   return null; // Return null if no location is selected
    // }

    return {
      page: currentPage,
      pageSize: currentPageSize,
      status: STATUS_FILTERS,
      type: tripNameMap[currentTab] || "",
      isInvoice: true,
      location: selectedLocation?.id,
      search: search,
    };
  };

  useEffect(() => {
    const filterData = getFilterData(page, pageSize);
    dispatch(getTrip(filterData));
  }, [page, pageSize, selectedLocation?.id, dispatch]);

  const updateQueryParams = (updates) => {
    const newParams = {
      page,
      pageSize,
      locationId: selectedLocation?.id,
      ...updates
    };
    setSearchParams(newParams);
  };

  // Table handlers
  const handleChangePage = (event, newPage) => {
    updateQueryParams({ page: newPage });
    const filterData = getFilterData(newPage, pageSize);
    dispatch(getTrip(filterData));
  };

  const handleChangeRowsPerPage = (event) => {
    const newPageSize = parseInt(event.target.value);
    updateQueryParams({ page: 0, pageSize: newPageSize });
    const filterData = getFilterData(0, newPageSize);
    dispatch(getTrip(filterData));
  };

  const handleRowClick = (data) => {
    navigate('/invoice/detail', {
      state: {
        id: data?.id,
        status: data?.status,
        customer: data?.customerName,
        driver: data?.driverName,
        tripId: data?.tripId,
        locationId: selectedLocation?.id,
      },
    });
  };

  const onSearch = debounce((searchValue) => {
    setSearch(searchValue);
    updateQueryParams({ page: 0 });

    const filterData = getFilterData(0, pageSize);
    dispatch(getTrip({ ...filterData, search: searchValue, page: 0 }));
  }, 1000);

  const handleChange = (event, newValue) => {
    navigate(`/invoice/${newValue}`);
    dispatch(setCurrentTab(newValue));
    const filterData = getFilterData(0, pageSize);
    dispatch(getTrip({ ...filterData, type: tripNameMap[newValue], search: search, page: 0 }));
  };


  return (
    <Grid item className="tableContainer marginTop15" xs={12}>
      <Box className="contentBoxStyle">
        <TabContext value={currentTab || ""}>
          <Grid
            container
            className="tabBoxStyle mb-10"
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            {/* Tab List - Takes available width */}
            <Grid item xs={12} sm={12} md={5} lg={6}>
              <TabList
                onChange={handleChange}
                aria-label="ride track tabs"
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1,
                  minHeight: '40px',
                }}
              >
                <Tab label="All" value="" className="tabStyle" />
                <Tab label="Ride" value="1" className="tabStyle" />
                <Tab label="Rental" value="5" className="tabStyle" />
                <Tab label="Airport" value="4" className="tabStyle" />
                <Tab label="OutStation" value="7" className="tabStyle" />
              </TabList>
            </Grid>

            {/* Location Dropdown + Search Box Container */}
            <Grid
              item
              container
              xs={12}
              sm={12}
              md={7}
              lg={6}
              spacing={2}
              sx={{
                display: 'flex',
                justifyContent: { xs: 'flex-start', md: 'flex-end' },
                alignItems: 'center',
              }}
            >
              {/* Location dropdown */}
              <Grid item xs={12} sm={6} md={5} lg={4}>
                <LocationDropdown className="location-dropdown" />
              </Grid>

              {/* Search Box */}
              <Grid item xs={12} sm={6} md={5} lg={4}>
                <CommonSDF onSearch={onSearch} search={search} />
              </Grid>
            </Grid>
          </Grid>

          {/* Table Panel */}
          <TabPanel value={currentTab || ""} sx={{ p: 0 }}>
            {loading ? (
              <Loader />
            ) : (
              <CommonTable
                data={tableData}
                onClickTableVendor={handleRowClick}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={pageSize}
                isClickable={true}
              />
            )}
          </TabPanel>
        </TabContext>
      </Box>
    </Grid>
  );
}

export default Invoice;